<template v-cloak>
  <div class="product-availability" :class="classes" >
    <div v-if="title" class="product-availability__title" style="white-space: nowrap;">{{ getTitle }}</div>
    <ul class="product-availability__dots">
      <li v-for="n in 5" :class="{ filled : n <= filledDots, }" ></li>
    </ul>
<!--	  <span style="padding-left: 10px; white-space: nowrap; line-height: 1;">{{ amount }} шт.</span>-->
  </div>
</template>

<script>
export default {
    name: 'ProductAvailability',
    props : {
        avgAmount : {
            type : Number,
            default : 0,
        },
        amount : {
            type : Number,
            default : 0,
        },
        title : {
            type : String,
            default : 'Наличие',
        },
    },
    methods  : {
        getDataDependence()
            {
                let returnData = {
                    "text" : "Нет в наличии",
                    "filledDots" : 0,
                    "class" : "product-availability--gray"
                };
                if(this.amount){
                    if(this.amount <= 3){
                        returnData = {
                            "text" : "Не более 3 шт",
                            "filledDots" : 2,
                            "class" : "product-availability--red"
                        };
                    }else if(this.amount <= 10){
                        returnData = {
                            "text" : "От 4 до 10 шт",
                            "filledDots" : 3,
                            "class" : "product-availability--yellow"
                        };
                    }else{
                        returnData = {
                            "text" : "Больше 10 шт",
                            "filledDots" : 5,
                            "class" : "product-availability--green"
                        };
                    }
                }
                return returnData;
            }
    },
    computed : {
        getTitle()
            {
                let text = "";

                let data = this.getDataDependence();
                if(data && data.text && data.text != ""){
                    text = data.text;
                }

                return text;
                //return this.title;
            },
        leftVal () {
            return this.avgAmount / 2;
        },
        filledDots () {
            let filledDots = 0;

            let data = this.getDataDependence();
            if(data && data.filledDots && data.filledDots != ""){
                filledDots = data.filledDots;
            }

            /*if (this.amount < this.leftVal) {
                filledDots = 2;
            }
            else if (this.amount > this.avgAmount) {
                filledDots = 5;
            }
            else {
                filledDots = 3;
            }*/
            return filledDots;
        },
        classes () {
            let classes = [];
            /*if (this.amount < this.leftVal) {
                classes.push('product-availability--red');
            }
            else if (this.amount > this.avgAmount) {
                classes.push('product-availability--green');
            }
            else {
                classes.push('product-availability--yellow');
            }
             return classes;
            */

            let data = this.getDataDependence();
            if(data && data.class && data.class != ""){
                classes.push(data.class);
            }
            return classes;
        },
    },
}
</script>
